import {StandardCard} from "@laser-project/kyui";
import {getJobStatusChips} from "../../StatusChips/JobStatusChips.tsx";
import React from "react";
import {IPopulatedJob} from "../../../types/FrontendTypes.ts";
import ImageRest from "../../../rest/ImageRest.ts";
import {Launch} from "@mui/icons-material";

export function ModalJobCard({job, imageRest}: { job: IPopulatedJob, imageRest: ImageRest }) {
    return <StandardCard
        key={job._id}
        image={imageRest.getUrlById(job.imageId)}
        imageAlt={`Rendered Model of ${job.title}`}
        title={job.title}
        chips={getJobStatusChips(job, true)}
        menuActions={[
            {
                label: "Go to job page",
                onClick: () => window.open(`/job/${job._id}`, '_blank'),
                icon: <Launch/>,
            },
        ]}
        type="model"
        condensed={true}
    />
}